<div class="reports-main-page position-relative">
  <div class="header-section row">
    <div
      class="col-12 d-flex date-section justify-content-between align-items-center"
    >
      <div class="name-text">
        <h5>Client Order</h5>
      </div>
      <div class="date-area">
        <mat-select
          class="form-control"
          [disableOptionCentering]="true"
          placeholder="Select Range"
          [formControl]="dateRangeControl"
          [compareWith]="compareFn"
          (selectionChange)="getData($event)"
        >
          <mat-option *ngFor="let type of selectionList" [value]="type?.value">
            {{ type?.name }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="counts d-flex col-12 mt-2">
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{ orderStatsData?.totalOrders ? orderStatsData?.totalOrders : 0 }}
        </p>
        <p class="box-names">Total Orders</p>
      </div>
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{ orderStatsData?.totalOrdersAmount | customCurrency }}
        </p>
        <p class="box-names">Total Orders Amount</p>
      </div>
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{ orderStatsData?.averageOrderAmount | customCurrency }}
        </p>
        <p class="box-names">Avg. Orders Ticket Size</p>
      </div>
    </div>
  </div>

  <div class="order-stats-section row">
    <div class="text-order-stats">
      <p>Activity</p>
      <h5>Order Stats</h5>
    </div>
    <canvas *ngIf="chart" id="canvas" baseChart>{{ chart }}</canvas>
  </div>
</div>
<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
